import { useStore } from 'effector-react'

import {
  $wallets,
  walletsListMounted,
  getWallets,
  $inProcess,
  allCurrenciesMounted,
  $allCurrencies,
} from './model'
import { useEffect } from 'react'

export const useWalletsList = () => {
  const wallets = useStore($wallets)
  const inProcess = useStore($inProcess)
  const loading = useStore(getWallets.pending)
  const allCurrencies = useStore($allCurrencies)

  useEffect(() => {
    walletsListMounted()
    allCurrenciesMounted()
  }, [])

  return { wallets, inProcess, loading, allCurrencies }
}
